import { CONTACT } from "@/lib/site";

export const Footer = () => (
  <footer className="bg-graphite text-stone-400 py-16 border-t border-stone-800 text-xs" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
        <div className="md:col-span-2">
          <span className="block text-sm font-bold text-white mb-2" data-testid="footer-firm">Diamond V, LLC · Ohio Geomatics</span>
          <p className="max-w-sm text-stone-400 leading-relaxed">
            Professional Civil Engineering, Land Surveying, and SUE solutions. Owned and operated by Steve Lamphear, PE, PS, RLS. Dublin, Ohio.
          </p>
        </div>
        <div>
          <span className="block font-bold text-white uppercase tracking-wider mb-3">Sections</span>
          <div className="flex flex-col space-y-2">
            <a href="#practice" className="hover:text-white transition-colors">Practice</a>
            <a href="#field-gallery" className="hover:text-white transition-colors">Field Gallery</a>
            <a href="#capabilities" className="hover:text-white transition-colors">Capabilities</a>
            <a href="#background" className="hover:text-white transition-colors">Background</a>
            <a href="#service-radius" className="hover:text-white transition-colors">Service Radius</a>
            <a href="#contact" className="hover:text-white transition-colors">Contact</a>
          </div>
        </div>
        <div>
          <span className="block font-bold text-white uppercase tracking-wider mb-3">Direct Email</span>
          <a href={`mailto:${CONTACT.email}`} className="text-stone-200 font-bold hover:text-white transition-colors" data-testid="footer-email">{CONTACT.email}</a>
          <p className="text-stone-400 mt-1">Dublin, Ohio</p>
        </div>
      </div>
      <div className="pt-8 border-t border-stone-800 text-stone-500 flex justify-between items-center">
        <p>Diamond V, LLC / Ohio Geomatics. All rights reserved.</p>
        <p>PE · PS · RLS Licensure in Ohio</p>
      </div>
    </div>
  </footer>
);
